import type { IMasterDataPurchaserRepository } from "@src/domain/repositories/masterData";
import type { GetMasterDataPurchasersDTO } from "@src/domain/dto/masterData";

export class GetMasterDataPurchasersUseCase {
  private readonly repository: IMasterDataPurchaserRepository;

  constructor(repository: IMasterDataPurchaserRepository) {
    this.repository = repository;
  }

  execute(params: GetMasterDataPurchasersDTO, brandKey?: string | null) {
    return this.repository.getPurchasers(params, brandKey);
  }
}
